import { API } from 'aws-amplify'

import {
  notifyQCLine,
  notifyReceiptRejected
} from '../graphql/mutations'

export const notifyToQCLine = async (pdOrder: string, division: string, claimMaterials: string) => {
  const postResult: any = await API.graphql({
    query: notifyQCLine,
    variables: { pdOrder, division, claimMaterials }
  })
  const returnResult = postResult.data?.notifyQCLine
  const response = JSON.parse(returnResult)
  if (response.statusCode === 400) throw new Error(response.message);
}

export const notifyOrderReceiptRejected = async (
  pdOrder: string, rejectFromDepartment: string, rejectToDepartment: string, rejectedAt: string, rejectNote: string, division: string) => {
  const postResult: any = await API.graphql({
    query: notifyReceiptRejected,
    variables: { 
      pdOrder, rejectFromDepartment, rejectToDepartment, rejectedAt, rejectNote, division
    }
  })

  const returnResult = postResult.data?.notifyReceiptRejected
  const response = JSON.parse(returnResult)
  if (response.statusCode === 400) throw new Error(response.message);
}